import useWarehouseTransferDetail from "src/hooks/warehouse-transfer/useWarehouseTransferDetail";
import { v4 as uuid } from "uuid";
import { Typography } from "@mui/material";
import MallScanner from "src/components/shared/ScanningInput";
import { useEffect } from "react";

export default function useExportPrepareProdBody({ item, setProdList, prodList, prodListFinished, setIndiProd, indiProd, setProdPick, prodPick }) {
  const { data: detail, isLoading: detailLoading, mutate: detailMutate } = useWarehouseTransferDetail(item?._id);

  const header = [
    {
      id: uuid(),
      title: "STT",
      width: "15px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Sản phẩm",
      width: "80px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Số lượng",
      width: "30px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Đã scan",
      width: "30px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      width: "35px",
      align: "center",
    },
  ];

  /**
   * Find the product currently being scanned
   */
  const activeProd = detail?.data?.transferDetails?.find((v) => v?._id === prodPick?._id);

  /**
   * Is the currently selected product finished?
   */
  const isActiveProdFinished = !!activeProd && Number(activeProd?.exportedQty ?? 0) >= Number(activeProd?.qty ?? 0);

  useEffect(() => {
    if (!detail?.data?.transferDetails?.length) return;

    setProdList(
      detail.data.transferDetails.map((v, i) => {
        const isFinished = Number(v?.exportedQty ?? 0) >= Number(v?.qty ?? 0);

        return {
          ...v,

          no: i + 1,

          prod: (
            <>
              {`${v?.productModel?.product?.name} (${v?.productModel?.name})`}

              <Typography
                sx={{
                  fontSize: "10px",
                  fontStyle: "italic",
                }}
              >
                ({v?.batch?.code ?? "-"})
              </Typography>
            </>
          ),

          progress: Number(v?.qty),

          require: isFinished,

          code: "-",

          scanned: `${v?.exportedQty ?? 0}/${Number(v?.qty ?? 0)}`,

          scanner: (
            <MallScanner
              label="scan"
              hideEnter
              getValue={setIndiProd}
              value={indiProd}
              extendState={v}
              fullLabel="Scan"
              code="importItemCodes"
              onCreate={() => {
                // Click the currently selected product
                if (prodPick?._id === v?._id) {
                  return setProdPick();
                }

                // Don't allow selecting a finished product
                if (isFinished) {
                  return;
                }

                // Start scanning this product
                setProdPick(v);
              }}
              /**
               * Disable other scanners ONLY when
               * the currently selected product is
               * still being scanned.
               */
              disabled={!!prodPick && !isActiveProdFinished && prodPick?._id !== v?._id}
              full={isFinished}
            />
          ),
        };
      }),
    );
  }, [detailLoading, detail?.data, detail?.data?.transferDetails?.length, prodListFinished, prodPick?._id, isActiveProdFinished]);

  const sortData = ["no", "prod", "progress", "return", "scanned", "scanner"];

  const totalTransferDetail = Array.isArray(detail?.data?.transferDetails) ? detail.data.transferDetails.find((v) => v?._id === prodPick?._id) : 0;

  return {
    header,
    sortData,
    loading: detailLoading,
    bodyList: prodList,
    totalTransferDetail,
    detailMutate,
    detail,
  };
}
